import {
  Badge,
  Box,
  Button,
  Grid2,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import burger from "../../assets/menuBurger.png";
import iceCream from "../../assets/menuIcecream.png";
import cafe from "../../assets/menuCafe.png";
import nuggets from "../../assets/menuNuggets.png";
import deals from "../../assets/menuDeals.png";
import fries from "../../assets/menufries.png";
import softdrink from "../../assets/menuSoftDrinks.png";
import wraps from "../../assets/menuWraps.png";
import footerImg from "../../assets/footerLogo.png";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setOpenCart,
  updateSelectedMenuItem,
} from "../../store/slice/Webshop.slice";
import { IMG_BASE_URL } from "../../utils/utils";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

const SelectMenuItemComponent = ({ handleMenu }) => {
  const {
    css
  }=useSelector((store)=> store?.widgetSettings);
  const menuCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Checkout fields + sidemnu"
  )?.fields

  const isSmallScreen=useMediaQuery('sm')
  const dispatch = useDispatch();
  const {
    webShopCategoryList,
    selectedMenuItem,
  } = useSelector((store) => store?.Webshop);
  const navigate = useNavigate();
  const handleMenuClick = (item) => {
    handleMenu(item);
    dispatch(updateSelectedMenuItem(item));
    navigate('/menu' )
  };
  return (
    <>
      <Box
        sx={{
          backgroundColor: menuCss?.menuListBgClr,
          p:2,
          minHeight:"100vh"
      
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
          <IconButton aria-label="back" color="warning">
            <ArrowBackIosNewRoundedIcon onClick={() => navigate(-1)} />
          </IconButton>
        </Box>

        <Box
          sx={{
            display:"flex",
           
            alignContent: "center", // Center vertically and horizontally
            flexWrap:"wrap",
            gap:"1rem",
            mt: 5,
           
          }}
        >
          {webShopCategoryList?.map((item, i) => (
            <Box
              key={i}
              sx={{
                width:isSmallScreen ? "100%" : "280px",
                backgroundColor:
                  selectedMenuItem?.name == item?.name ? menuCss?.menuListHighlightBgClr : "#fff",
                borderRadius: "18px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "10px",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                cursor: "pointer",
                transition: "transform 0.3s ease",
                color: "#000000",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
                },
              }}
              onClick={() => {
                // dispatch(updateSelectedMenuItem(item))
                // navigate(`/webshopMenu`)
                handleMenuClick(item);
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "0",
                  paddingTop: "100%", // Aspect ratio 1:1
                  position: "relative",
                  borderRadius: "16px",
                  overflow: "hidden",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {item?.imageFileName ? (
                  <img
                    src={`${IMG_BASE_URL}/upload/WebshopCategory${item.imageFileName.replace(
                      /\\/g,
                      "/"
                    )}`}
                    alt={item?.name}
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                      objectFit: "contain", // Maintain aspect ratio
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                ) : null}
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "700",
                  mt: 1,
                  color:
                    selectedMenuItem?.name == item?.name ? "#fff" : menuCss?.menuListTextClr,
                }}
              >
                {item?.name}
              </Typography>
              <Typography
                sx={{
                  color:
                    selectedMenuItem?.name == item?.name ? "#fff" : menuCss?.menuListTextClr,
                  fontSize: "12px",
                  lineHeight: "1.4rem",
                  textAlign: "center",
                  mt: 1,
                }}
              >
                {item?.info}
              </Typography>
            </Box>
          ))}
        </Box>
        <Grid2 container mt={4} sx={{ width: "100%"}}>
          <Grid2 size={{ md: 2 }}>
            <Box
              sx={{
                //   flex: "0 1 auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <img
                src={footerImg}
                alt="footerLogo"
                style={{ minWidth: "76px", height: "auto" }}
              />
            </Box>
          </Grid2>
          <Grid2 size={{ md: 7 }}>
            <Typography sx={{ color: "#969BA0" }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vel
              ipsum eget nisi placerat viverra. Donec non ipsum vel nisi
              fermentum consectetur. Nulla facilisi. Donec id velit vel eros
              dictum tempor.
            </Typography>
          </Grid2>
         
        </Grid2>
      </Box>
    </>
  );
};

export default SelectMenuItemComponent;
